import StarsInput from '@common/forms/fields/StarsInput'
import { useAppSelector, useTranslate } from '@common/hooks'
import ModalWrapper from '@common/modals/ModalWrapper'
import Button from '@common/widgets/Button'
import { useState } from 'react'

import ModalForm from '../RatingForm/ModalForm'
import classNames from './styles.module.scss'


export default function MyReview(): JSX.Element | null {
  const [formIsOpen, setFormIsOpen] = useState(false)
  const { translate } = useTranslate()
  const rating = useAppSelector(store => store.applicationRating.data?.rating)

  if(!rating) {
    return null
  }

  return (
    <div className={classNames.container}>
      <StarsInput
        onChange={() => () => setFormIsOpen(true)} value={rating.score}
        disableHover
        className={classNames.stars}
      />
      <Button
        variant="light"
        width="md"
        className={classNames.updateBtn}
        onClick={() => setFormIsOpen(true)}
        data-test="update-review-btn"
      >
        {translate('Update my review')}
      </Button>
      <ModalWrapper
        component={ModalForm}
        show={formIsOpen}
        onHide={() => {
          setFormIsOpen(false)
        }}
        size="lg"
        modalClassName={classNames.modal}
        initialValues={{
          body: rating.body,
          score: rating.score,
          title: rating.title,
          id: rating.id,
        }}
        editMode
      />
    </div>
  )
}
